// extracted by mini-css-extract-plugin
export default {"list":"ConversationBubble_list__xax3d"};